globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Public = appCustomerSpace.Controllers.Public || {};

appCustomerSpace.Controllers.Public.WelcomeEmailingBuilderController = (function (superClass) {

  utils.extend(WelcomeEmailingBuilderController, superClass);

  function WelcomeEmailingBuilderController() {
    return WelcomeEmailingBuilderController.__super__.constructor.apply(this, arguments);
  }

  $.extend(WelcomeEmailingBuilderController.prototype, {
    init: function () {
      this.refreshTimeout = null;
      return WelcomeEmailingBuilderController.__super__.init.apply(this, arguments);
    },

    initReloadWithoutEdit: function () {
      var _this = this;
      this.refreshTimeout = null;
      _this._initDisplayButtons();
      _this._initMinusPlusButtons();
      _this._initAccordion();

      var $form = $($.find('form'));
      $form.on('submit', function (e) {
        e.preventDefault();
        values = $form.serialize();
        urlSubmit = $form.attr('action');
        var callbackSuccess = function (data) {
          if (data.response == 1) {
            _this._reloadPreview(data.preview_html, data.subject);
          }
        };
        $.post(urlSubmit, values, callbackSuccess, 'json');
      });
    },

    initEditor: function () {
      var _this = this;

      this._initMessageIframe();
      this._initDisplayButtons();
      this._initMinusPlusButtons();
    },

    _initRemoveLastArticlesElementFilterArticleAssociation: function () {
      var _this = this;
      $(document).off("click.removeLastArticlesFilter").on("click.removeLastArticlesFilter", ".btn-remove-last-articles-element-filter-article-association", function (e) {
        e.preventDefault();
        var $this = $(this);
        var url = $this.data("url");
        $.ajax({
          url: url,
          method: "POST",
          success: function (data) {
            if (data.response == 1) {
              $('#filters-resume').replaceWith(data.html);
              _this._reloadPreview(data.preview_html);
            }
          }
        });
      });
    },

    _initAccordion: function (active) {
      if ($(".accordion").length == 0)
        return
      var options = {
        collapsible: true,
        heightStyle: "content",
      };
      if (active !== undefined) options.active = active;
      $accordion = $(".accordion");
      $accordion.first().accordion(options);
    },
    _bindMutedTitles: function() {
      $(".element-checkbox").on('input', function(event) {
        var currentTarget = $(event.currentTarget)
        var dataTarget = currentTarget.data("title-target")
        var title = $(`#${dataTarget}`)
        title.toggleClass("section-active")
      })
    },
    _findAccordionIndex: function ($accordion, headerId) {
      var $headers = $accordion.find('> .ui-accordion-header');
      var foundIndex = false;
      $headers.each(function (index) {
        if ($(this).attr('id') === headerId) {
          foundIndex = index;
          return false;
        }
      });
      return foundIndex;
    },

    _refreshAccordion: function () {
      if ($(".accordion").length == 0)
        return
      var $accordion = $(".accordion");

      var $content = $accordion.find('.ui-accordion-content'),
        windowHeight = $(window).height(),
        accordionTop = $accordion.offset().top,
        $buttons = $accordion.find('h5'),
        heightTotalButtons = $buttons[0].offsetHeight * $buttons.length,
        heightMax = windowHeight - accordionTop - heightTotalButtons;

      $content.css({
        height: heightMax - 90 + 'px',
        overflowY: 'auto'
      });
    },

    _initDisplayButtons: function () {
      $(".btn-mail-display").on("click", function (e) {
        e.preventDefault();
        if ($(e.currentTarget).data('display') == 'phone') {
          $(".mail-preview-panel").css('width', "400px");
          $(".mail-preview-header").css('width', "400px");
        } else {
          $(".mail-preview-panel").css('width', "90%");
          $(".mail-preview-header").css('width', "90%");
        }
      });
    },

    _initMinusPlusButtons: function () {
      if ($(".design-font-size-inputs").length != 0) {
        $(".design-font-size-inputs").each(function () {
          var $this = $(this);
          var $input = $this.find("input");
          $this.find(".minus-font-size-btn").on("click", function (e) {
            $input.val(parseInt($input.val()) - 1);
            $input.trigger("change");
            $input.trigger("click");
          });
          $this.find(".plus-font-size-btn").on("click", function (e) {
            $input.val(parseInt($input.val()) + 1);
            $input.trigger("change");
            $input.trigger("click");
          });
        });
      }
    },

    _initMessageIframe: function () {
      var _this = this;

      window.addEventListener('message', function (e) {
        var $iframe = $(".mail-preview-panel").find("iframe");

        const eventDomain = new URL(e.origin).hostname;
        if (eventDomain == $iframe.data('origin') && e.data) {
          var data = e.data;
          var iframeContentWindow = $iframe.get(0).contentWindow;
          iframeContentWindow.postMessage(data, '*');

          if (data.action == "EditSection") {
            _this._startLoader();
            _this._editSection(data);
          } else if (data.action == "AddSection") {
            _this._startLoader();
            _this._addSection(data);
          } else if (data.action == "ConfirmDestroySection") {
            _this._startLoader();
            _this._confirmDestroySection(data);
          } else if (data.action == "MoveSection") {
            _this._moveSection(data);
          } else if (data.action == "DuplicateSection") {
            _this._startLoader();
            _this._duplicateSection(data);
          }
        }
      });
    },

    _initTitlesRadioButtons: function (radioInputs) {
      radioInputs.on('change', function (e) {
        var $label = $(e.currentTarget);
        $label.siblings().removeClass('btn-c2').addClass('btn-default');
        $label.removeClass('btn-default').addClass('btn-c2');
      });
    },

    _editSection: function (data) {
      var _this = this;
      var tagName = data.tagName;
      var type = data.type;
      if (_this.editSectionRequest) _this.editSectionRequest.abort();
      _this.editSectionRequest = $.ajax({
        url: $("#section-form").data('edit-url'),
        data: data,
        success: function (data) {
          if (data.response == 1) {
            _this._clearSelection(function () {
              _this._initSelection(data, tagName, type);
            });
          }
        }
      });
    },

    _addSection: function (data) {
      var _this = this;

      $.ajax({
        url: $("#section-form").data('add-url'),
        data: data,
        success: function (data) {
          if (data.response == 1) {
            _this._clearSelection(function () {
              _this._initSelection(data);
              _this._reloadPreview(data.preview_html);
            });
          }
        }
      });
    },

    _moveSection: function (data) {
      var _this = this;

      $.ajax({
        url: $("#section-form").data('move-url'),
        data: data,
        success: function (data) {
          if (data.response == 1) {
            _this._clearSelection(function () {
              _this._reloadPreview(data.preview_html);
            });
          }
        }
      });
    },

    _duplicateSection: function (data) {
      var _this = this;

      $.ajax({
        url: $("#section-form").data('duplicate-url'),
        data: data,
        success: function (data) {
          if (data.response == 1) {
            _this._clearSelection(function () {
              _this._initSelection(data);
              _this._reloadPreview(data.preview_html);
            });
          }
        }
      });
    },

    _confirmDestroySection: function (data) {
      var _this = this;

      $.ajax({
        url: $("#section-form").data('confirm-destroy-url'),
        data: data,
        success: function (data) {
          if (data.response == 1) {
            _this._clearSelection(function () {
              _this._initSelection(data);
              $($.find("#destroy-btn")).on('click', function (e) {
                _this._destroySection({ section_uniq_key: data.section_uniq_key });
              });
            });
          }
        }
      });
    },

    _destroySection: function (data) {
      var _this = this;

      $.ajax({
        url: $("#section-form").data('destroy-url'),
        data: data,
        success: function (data) {
          if (data.response == 1) {
            _this._clearSelection(function () {
              _this._reloadPreview(data.preview_html);
            });
          }
        }
      });
    },

    _clearSelection: function (callback) {
      if (typeof (callback) == 'function' && (typeof (this.$currentPartial) === 'undefined' || this.$currentPartial.length == 0))
        return callback();

      this.$currentPartial.remove();
      if (typeof (callback) == 'function') callback();
    },

    _initSelection: function (data, tagName = null, type = null, activeIndex = null) {
      var _this = this,
        $tab = $(".email-content-editor #section-form .tab-content");

      _this.$currentPartial = $(data.html);
      _this.$currentPartial.appendTo($tab);

      appCustomerSpace.CKEditor.init(_this.$currentPartial);
      var $form = _this.$currentPartial.find('form');
      _this._initTitlesRadioButtons(_this.$currentPartial.find('.titles-radio-input'));
      _this._initTitlesRadioButtons(_this.$currentPartial.find('.texts-radio-input'));
      _this._initTitlesRadioButtons(_this.$currentPartial.find('.links-radio-input'));
      _this._initTitlesRadioButtons(_this.$currentPartial.find('.widths-radio-input'));
      _this._initRemoveLastArticlesElementFilterArticleAssociation();
      setTimeout(function () {
        if (tagName) {
          _this._initAccordion(false);
        } else {
          _this._initAccordion();
        }
        _this._bindMutedTitles();
        var $accordion = _this.$currentPartial.find('.accordion');
        if (tagName) {
          var headerId = null;
          if (type == 'BusinessServices::Emailing::Email::Sections::LastArticlesSection' && (tagName == 'A' || tagName == 'P' || tagName == 'IMG')) {
            headerId = 'articles-title';
          } else if (tagName == 'H1' || tagName == 'H2' || tagName == 'H3' || tagName == 'H4') {
            headerId = 'title-title';
          } else if (tagName == 'P') {
            headerId = 'text-title';
          } else if (tagName == 'IMG') {
            headerId = 'image-title';
          } else if (tagName == 'A') {
            headerId = 'link-title';
          }

          if (headerId !== null) {
            var headerIndex = _this._findAccordionIndex($accordion, headerId);
            if (headerIndex !== false) {
              $accordion.accordion('option', 'active', headerIndex);
            }
          }
        } else if (activeIndex !== null) {
          $accordion.accordion('option', 'active', activeIndex);
        }
      }, 0);

      _this._needsPartialRefresh = false;

      $form.find('[name$="[text_and_image_display_type]"], [name$="[percent_image_column_width]"]')
        .on('change', function () {
          _this._needsPartialRefresh = true;
        });

      $form.on('submit', function (e) {
        e.preventDefault();
        var values = $form.serialize();
        var urlSubmit = $form.attr('action');

        if (_this._needsPartialRefresh) _this._startLoader();

        var callbackSuccess = function (data) {
          if (data.response == 1) {
            var isCreateSection = urlSubmit.split("/").pop() === "create_section";

            if (isCreateSection) {
              _this._startLoader();
              _this._clearSelection(function () {
                _this._initSelection(data);
                _this._reloadPreview(data.preview_html);
              });
            } else if (_this._needsPartialRefresh) {
              _this._needsPartialRefresh = false;
              var $accordion = _this.$currentPartial.find('.accordion');
              var currentActiveIndex = $accordion.length > 0 ? $accordion.accordion('option', 'active') : null;
              _this._clearSelection(function () {
                _this._initSelection(data, null, null, currentActiveIndex);
                _this._reloadPreview(data.preview_html);
              });
            } else {
              _this._reloadPreview(data.preview_html);
            }
          }
        };
        $.post(urlSubmit, values, callbackSuccess, 'json');
      });

      $form.on('customer-space--image-content:updated customer-space--image-content:deleted', function () {
        $form.trigger('submit');
      });

      _this.$currentPartial.on('click', 'button[type=close]', function () {
        _this._clearSelection();
      });

      appCustomerSpace.LimitlessPlugins.initPlugins(_this.$currentPartial);
      _this._initWidthToggle(_this.$currentPartial);
      _this.$currentPartial.show();
      appCustomerSpace.Loader().stop({
        $container: $tab,
        options: { style: { backdrop: { background: "#fff" } } }
      });
    },

    _reloadPreview: function (preview_html, subject) {
      var _this = this;
      appCustomerSpace.Loader().start({
        $container: $(".mail-preview-panel"),
        options: { style: { backdrop: { background: "rgba(255, 255, 255, 0.6)" } } }
      });
      if (_this.refreshTimeout) clearTimeout(_this.refreshTimeout);
      _this.refreshTimeout = setTimeout(function () {
        var $iframe = $(".mail-preview-panel").find("iframe");
        var iframeContentWindow = $iframe.get(0).contentWindow;
        const scrollTop = iframeContentWindow.document.documentElement.scrollTop || iframeContentWindow.document.body.scrollTop;

        if (subject !== 'undefined') {
          $(".mail-preview-header").find('h5').text(subject);
        }

        $iframe.attr('srcdoc', preview_html);
        $iframe.on('load', function () {
          iframeContentWindow.scrollTo(0, scrollTop);
        });
        appCustomerSpace.Loader().stop({
          $container: $(".mail-preview-panel"),
          options: { style: { backdrop: { background: "rgba(255, 255, 255, 0.6)" } } }
        });
      }, 500);
    },

    _initWidthToggle: function ($partial) {
      var fullWidthTypes = ['image_top', 'image_bottom', 'image_middle'];
      var defaultWidth = 'width_50';
      var $displayTypeRadios = $partial.find('[name$="[text_and_image_display_type]"]');
      var $widthButtons = $partial.find('[data-width-buttons]');
      var $widthFull = $widthButtons.find('[data-width-full]');
      var $widthLabels = $widthButtons.find('.widths-radio-input');
      var $widthRadios = $widthLabels.find('input');

      if ($displayTypeRadios.length === 0 || $widthButtons.length === 0) return;

      $displayTypeRadios.on('change', function () {
        var isFullWidth = fullWidthTypes.indexOf($(this).val()) !== -1;

        $widthFull.toggle(isFullWidth);
        $widthLabels.toggle(!isFullWidth);

        if (isFullWidth) {
          $widthFull.tooltip();
        } else {
          $widthFull.tooltip('destroy');
          if ($widthRadios.filter(':checked').length === 0) {
            var $defaultRadio = $widthRadios.filter('[value="' + defaultWidth + '"]');
            $defaultRadio.prop('checked', true);
            $widthLabels.removeClass('btn-c2').addClass('btn-default');
            $defaultRadio.closest('label').removeClass('btn-default').addClass('btn-c2');
          }
        }
      });
    },

    _startLoader: function () {
      appCustomerSpace.Loader().start({
        $container: $(".email-content-editor #section-form .tab-content"),
        options: { text: "", style: { backdrop: { background: "#fff" } } }
      });
    }
  });

  return WelcomeEmailingBuilderController;

})(appCustomerSpace.Controllers.Public.MainController);
